import { FormGroup } from "@blueprintjs/core";
import React, { useEffect } from "react";
import TextField from "../../BaseInputFields/TextField/TextField";
import { FieldLabel, NameFieldValue } from "@ucl/library";
import "./styles.scss";

import { BaseFieldProps } from "../../types/fieldTypes";
import { getErrorMessagesFromErrorMessages } from "../../../../utils/field";
export interface NameFieldProps extends BaseFieldProps<NameFieldValue> {
  type: "Name";
}
export const NameField: React.FC<NameFieldProps> = ({
  label,
  description,
  value,
  onSubmit,
  disabled,
  hidden,
  errorMessages,
  isRequired,
}) => {
  if (hidden) {
    return null;
  }

  const [localValue, setLocalValue] = React.useState<NameFieldValue>({
    firstName: value?.firstName || "",
    lastName: value?.lastName || "",
  });

  useEffect(() => {
    onSubmit?.(localValue);
  }, [localValue]);

  return (
    <FormGroup className="base-field">
      {label && (
        <FieldLabel labelName={label} tooltipDescription={description} isRequired={isRequired} />
      )}
      <div className="name-field">
        <div className="name-field_input name-field_first-name">
          <TextField
            value={localValue.firstName}
            inputMode="text"
            type="Text"
            disabled={disabled}
            placeholder={"First Name"}
            onSubmit={(value) => {
              setLocalValue({ ...localValue, firstName: value as string });
            }}
            isRequired={isRequired}
            errorMessages={getErrorMessagesFromErrorMessages(
              errorMessages,
              "FirstName"
            )}
          />
        </div>
        <div className="name-field_input">
          <TextField
            value={localValue.lastName}
            inputMode="text"
            type="Text"
            disabled={disabled}
            placeholder={"Last Name"}
            isRequired={isRequired}
            onSubmit={(value) => {
              setLocalValue({ ...localValue, lastName: value as string });
            }}
            errorMessages={getErrorMessagesFromErrorMessages(
              errorMessages,
              "LastName"
            )}
          />
        </div>
      </div>
    </FormGroup>
  );
};
